import { defaultLinkText, personalizationSnippet } from './snippets.js'

// What an editor's personalization menu inserts. A link-shaped tag first asks the author for the
// text to display, the way making a link does. Returns null when they cancel: insert nothing.
export function promptedPersonalizationSnippet(key, { label } = {}) {
  const defaultText = defaultLinkText(key, { label })
  if (defaultText === null) return personalizationSnippet(key, { label })

  const typed = globalThis.prompt('Text to display', defaultText)
  if (typed === null) return null

  return personalizationSnippet(key, { label, linkText: typed.trim() })
}
